import React, { memo, useContext } from 'react';
import classnames from 'classnames';
import StepperStateContext from 'common/Stepper/StateContext';
import Tab from './Tab';
import './Stepper.scss';

const Stepper = ({ className = '' }) => {
  const { steps, currentStep } = useContext(StepperStateContext);
  const classes = classnames('Stepper', className);

  return (
    steps?.length > 0 && (
      <div className={classes}>
        {steps.map((step, index) => (
          <Tab key={step} name={step} active={index === currentStep} done={index < currentStep} />
        ))}
      </div>
    )
  );
};

export default memo(Stepper);
